import {
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  GET_HOME_CHARGERS_SUCCESS,
  GET_HOME_CHARGERS_FAILURE,
  SET_HOME_CHARGERS_DISPLAY,
  CLEAR_HOME_CHARGERS,
  GET_3RD_PARTY_CHARGERS_SUCCESS,
  GET_3RD_PARTY_CHARGERS_FAILURE,
  GET_SELECTED_LOCATION_DETAIL_SUCCESS,
  GET_SELECTED_LOCATION_DETAIL_FAILURE,
  GET_LOCATIONS_DETAIL_SUCCESS,
  GET_LOCATIONS_DETAIL_FAILURE,
  CLEAR_SELECTED_LOCATION_DETAIL,
  SET_MAP_MODE,
  SET_FILTER,
  SET_CURRENT_LOCATION,
} from '../../types';
import { MAP_MODE, CHARGER_TYPES } from '../../../consts/locationConst';

export const initialState = {
  common: {
    mode: MAP_MODE.MAP,
    currentLocation: {},
    selectedFilters: Object.values(CHARGER_TYPES),
    locationsPrice: null,
  },
  selectedLocation: { locationDetailInfo: null },
  thirdPartyChargers: { items: [], loaded: false },
  locations: { items: [], loaded: false },
  homeChargers: { display: false, data: null, loaded: false },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: { items: action?.payload, loaded: true },
      };
    case GET_LOCATIONS_FAILURE:
      return {
        ...state,
        locations: { items: [], loaded: true },
      };
    case GET_HOME_CHARGERS_SUCCESS:
      return {
        ...state,
        homeChargers: { ...state.homeChargers, data: action?.payload?.data, loaded: true },
      };
    case SET_HOME_CHARGERS_DISPLAY:
      return {
        ...state,
        homeChargers: { ...state.homeChargers, display: action?.payload },
      };
    case CLEAR_HOME_CHARGERS:
    case GET_HOME_CHARGERS_FAILURE:
      return {
        ...state,
        homeChargers: { data: null, loaded: true, display: false },
      };
    case GET_3RD_PARTY_CHARGERS_SUCCESS:
      return {
        ...state,
        thirdPartyChargers: { items: action?.payload, loaded: true },
      };
    case GET_3RD_PARTY_CHARGERS_FAILURE:
      return {
        ...state,
        thirdPartyChargers: { items: [], loaded: false },
      };
    case GET_SELECTED_LOCATION_DETAIL_SUCCESS:
      return {
        ...state,
        selectedLocation: { ...state.selectedLocation, locationDetailInfo: action?.payload },
      };
    case GET_SELECTED_LOCATION_DETAIL_FAILURE:
    case CLEAR_SELECTED_LOCATION_DETAIL:
      return {
        ...state,
        selectedLocation: { ...state.selectedLocation, locationDetailInfo: null },
      };
    case GET_LOCATIONS_DETAIL_SUCCESS:
      return {
        ...state,
        common: { ...state.common, locationsPrice: action?.payload },
      };
    case GET_LOCATIONS_DETAIL_FAILURE:
      return {
        ...state,
        common: { ...state.common, locationsPrice: null },
      };
    case SET_MAP_MODE:
      return {
        ...state,
        common: { ...state.common, mode: action?.payload },
      };
    case SET_FILTER:
      return {
        ...state,
        common: { ...state.common, selectedFilters: action?.payload },
      };
    case SET_CURRENT_LOCATION:
      return {
        ...state,
        common: { ...state.common, currentLocation: action?.payload },
      };
    default:
      return {
        ...state,
      };
  }
};
